import i18n from 'app/utils/translation/i18n';

interface Aliases {
  value: string;
  label: string;
  maxLength?: number;
}

let aniPayTypes: Aliases[];
let clientTypes: Aliases[];
let beneficiaryCodes: Aliases[];

i18n.on('loaded', () => {
  aniPayTypes = [
    { value: 'PIN', label: i18n.t('anipay.pin'), maxLength: 7 },
    { value: 'EMAIL', label: i18n.t('anipay.email'), maxLength: 50 },
    { value: 'MOBILE', label: i18n.t('anipay.mobileNumber') },
    { value: 'TIN', label: i18n.t('anipay.tin'), maxLength: 10 },
    { value: 'IBAN', label: i18n.t('anipay.iban'), maxLength: 28 },
  ];

  clientTypes = [
    { value: 'PHYSICAL', label: i18n.t('anipay.physicalPerson') },
    { value: 'ENTREPRENEUR', label: i18n.t('anipay.entrepreneur') },
    { value: 'JURIDICAL', label: i18n.t('anipay.juridicalPerson') },
  ];

  beneficiaryCodes = [
    { value: 'IBAN', label: 'IBAN' },
    { value: 'ACCOUNT', label: i18n.t('anipay.beneficiaryAccountNumber') },
  ];
});

export { aniPayTypes, beneficiaryCodes, clientTypes };
